<template>
  <div class="misc-wrapper">

    <!-- 標題 -->
    <b-link class="brand-logo">
      <vuexy-logo />
      <h2 class="brand-text text-primary">
        曠世國際有限公司
      </h2>
    </b-link>

    <!-- 內容 -->
    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">

        <!-- 小標題 -->
        <h2 class="mb-1">
          You are not authorized! 🔐
        </h2>

        <!-- 小標題說明 -->
        <p class="mb-2">
          You don’t have permission to access this page. Go Home!!
        </p>

        <!-- 導向按鈕 -->
        <b-button
          variant="primary"
          class="mb-1 btn-sm-block"
          :to="loginRoute()"
        >Back to Home</b-button>

        <!-- 背景圖 -->
        <b-img
          fluid
          :src="imgUrl"
          alt="Not authorized page"
        />
      </div>
    </div>
  </div>
</template>

<script>
// API
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
// UI
import { BLink, BImg, BButton } from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'

export default {
  components: {
    BLink,
    BImg,
    BButton,

    VuexyLogo,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/not-authorized.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/not-authorized-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  methods: {
    loginRoute() {
      const user = JSON.parse(localStorage.getItem('userData'))
      return getHomeRouteForLoggedInUser(user ? user.role : null)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';

.misc-wrapper{
  min-height: 75vh;
}
</style>
